import script from "./PatientSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientSummary.vue?vue&type=script&setup=true&lang=js"

import "./PatientSummary.vue?vue&type=style&index=0&id=0b81ca10&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b81ca10"]])

export default __exports__